import Tips from "./components/Tips";
import LinkWordModal from "./components/LinkWordModal";
import { uniqueId } from "@/views/zhiji/js/common/util.js";

const color = "#26a2ff";

// link，question，higlight配置
export default {
    type: "link",
    labelKey: "zhiji.answer.textWidget.textLink",
    cls: "text-opt-link",
    tipsComponent: Tips,
    editorHandler: (store, data, cb) => {
        store.dispatch("zhiji/showModal", {
            type: LinkWordModal,
            data: {
                type: data.operate,
                id: data && data.id,
                word: data.word,
                url: data.url || "",
                colorType: (data && data.colorType) || "outColor",
                colorData: {
                    outColor: color,
                    innerColor: color
                },
                confirm: link => {
                    const id = data.id || `${uniqueId()}`;
                    const elem = {
                        id,
                        tag: "span",
                        innerText: link.word,
                        editable: false,
                        attrs: [
                            { name: "data-type", value: "link" },
                            { name: "link-color", value: link.urlType.colorType }
                        ],
                        styles: [{ name: "color", value: link.urlType.color }]
                    };
                    const node = {
                        id,
                        type: "link",
                        word: link.word,
                        url: link.url,
                        colorType: link.urlType.colorType,
                        linkType: link.linkType
                    };

                    cb({ elem, node, operate: link.type });
                },
                cancel: () => {
                    // TODO
                }
            }
        });
    },
    toHtml(node) {
        const colorType = node.linkType == "new_page" ? "outColor" : "innerColor";
        return `<span id=${node.id} style="color: ${color}" data-type="link" link-color="${colorType}" contenteditable="false">${node.word}</span>`;
    },
    fromOut(word) {
        return {
            ...word,
            colorType: word.linkType == "new_page" ? "outColor" : "innerColor"
        };
    },
    toOut(node) {
        return {
            ...node
        };
    },
    getTips(node) {
        return node.url;
    }
};
